export enum SupervisorQueueTaskColumns {
  taskName,
  escalatedUserName,
  reason,
  patientName,
  id,
  createDate,
}
